import { render, staticRenderFns } from "./Coin.vue?vue&type=template&id=dc6a0852&scoped=true"
import script from "./Coin.vue?vue&type=script&lang=js"
export * from "./Coin.vue?vue&type=script&lang=js"
import style0 from "./Coin.vue?vue&type=style&index=0&id=dc6a0852&prod&lang=postcss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc6a0852",
  null
  
)

export default component.exports